import React from "react";
import PropTypes from "prop-types";

import {
  CONTRIBUTING_TO_VARSOME_URL,
  DATA_TIP_TEXT,
} from "./constants/form-constants";

const HowToSubmitToClinVar = ({ classes }) => (
  <span className={`tw-float-right tw-text-2xs ${classes}`}>
    <span className="tw-mr-1 tw-align-sub">
      <i className="varsome-icons icon-info" data-tooltip={DATA_TIP_TEXT} />
    </span>
    <span className="tw-mr-rem-1 tw-align-sub">
      <a href={CONTRIBUTING_TO_VARSOME_URL} target="_blank">
        How to submit to ClinVar
      </a>
    </span>
  </span>
);

HowToSubmitToClinVar.propTypes = {
  classes: PropTypes.string,
};

HowToSubmitToClinVar.defaultProps = {
  classes: "",
};

export default HowToSubmitToClinVar;
